<ion-header>
  <ion-toolbar>
    <ion-title class="ion-text-start">{{ viewOnly ? ('SIGNATURES_CAPTURED' | translate) : ('CAPTURE_SIGNATURES' | translate) }}</ion-title>
    <ion-buttons slot="end">
      <ng-container *ngIf="!viewOnly">
        <ion-button (click)="cancel()">{{ 'CANCEL' | translate }}</ion-button>
        <ion-button [disabled]="!canSubmit" (click)="submit()">{{ 'SUBMIT' | translate }}</ion-button>
      </ng-container>
      <ion-button *ngIf="viewOnly" (click)="cancel()">{{ 'CLOSE' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="modal-body ion-padding">
  <!-- HCP Signature Terms Section -->
  <div class="terms-section" *ngIf="shouldShowTermsSection">
    <ind-section-header
      [viewData]="termsSectionHeaderViewData"
      (onControlClick)="onSectionHeaderControlClick($event)">
    </ind-section-header>
    <div class="terms-content">
      <div id="miTermBodyContainer"
           [ngClass]="isTermsViewLess ? 'view-less' : 'view-all'"
           *ngIf="termBodyView"
           [innerHTML]="termBodyView">
      </div>
    </div>
  </div>

  <!-- HCP Signature Section -->
  <div class="signature-section" *ngIf="shouldShowHcpSection">
    <ind-section-header
      [viewData]="hcpSectionHeaderViewData"
      (onControlClick)="onSectionHeaderControlClick($event)">
    </ind-section-header>
    <div #hcpSignatureCaptureArea class="signature-capture-area">
      <div class="signaturePadWrapper" *ngIf="!viewOnly">
        <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag" alt="Sign" />
        <signature-pad
          #hcpSignaturePad
          [options]="signaturePadOptions"
          (onBeginEvent)="onHcpDrawStart()"
          (onEndEvent)="onHcpDrawEnd()">
        </signature-pad>
      </div>
      <div class="signature-view-only" *ngIf="viewOnly && hcpSignatureImage">
        <img [src]="hcpSignatureImage" alt="HCP Signature" class="signature-image" />
      </div>
    </div>
    <div class="signature-meta" *ngIf="hcpSignatureCaptured || (viewOnly && hcpSignatureImage)">
      <ng-container *ngIf="!viewOnly">
        <p *ngIf="hcpSignedBy">{{ 'SIGNED_BY' | translate }}: {{ hcpSignedBy }}<span *ngIf="hcpSignatureDate">, {{ hcpSignatureDate | customDate:'DATE_TIME' }}</span></p>
        <p *ngIf="repSignatureCapturedBy">{{ 'SIGNATURE_CAPTURED_BY' | translate }}: {{ repSignatureCapturedBy }}</p>
      </ng-container>
      <ng-container *ngIf="viewOnly">
        <p *ngIf="hcpSignedBy">{{ 'SIGNED_BY' | translate }}: {{ hcpSignedBy }}<span *ngIf="viewOnlyHcpSignatureDate">, {{ viewOnlyHcpSignatureDate }}</span></p>
        <p *ngIf="repSignatureCapturedBy">{{ 'SIGNATURE_CAPTURED_BY' | translate }}: {{ repSignatureCapturedBy }}</p>
      </ng-container>
    </div>
  </div>

  <!-- User/Rep Signature Section -->
  <div class="signature-section" *ngIf="shouldShowRepSection">
    <ind-section-header
      [viewData]="repSectionHeaderViewData"
      (onControlClick)="onSectionHeaderControlClick($event)">
    </ind-section-header>
    <div #repSignatureCaptureArea class="signature-capture-area">
      <div class="signaturePadWrapper" *ngIf="!viewOnly">
        <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag" alt="Sign" />
        <signature-pad
          #repSignaturePad
          [options]="signaturePadOptions"
          (onBeginEvent)="onRepDrawStart()"
          (onEndEvent)="onRepDrawEnd()">
        </signature-pad>
      </div>
      <div class="signature-view-only" *ngIf="viewOnly && repSignatureImage">
        <img [src]="repSignatureImage" alt="User Signature" class="signature-image" />
      </div>
    </div>
    <div class="signature-meta" *ngIf="repSignatureCaptured || (viewOnly && repSignatureImage)">
      <ng-container *ngIf="!viewOnly">
        <p>{{ 'SIGNED_BY' | translate }}: {{ repSignatureCapturedBy }}<span *ngIf="repSignatureDate">, {{ repSignatureDate | customDate:'DATE_TIME' }}</span></p>
        <p>{{ 'SIGNATURE_CAPTURED_BY' | translate }}: {{ repSignatureCapturedBy }}</p>
      </ng-container>
      <ng-container *ngIf="viewOnly">
        <p>{{ 'SIGNED_BY' | translate }}: {{ repSignatureCapturedBy }}<span *ngIf="viewOnlyRepSignatureDate">, {{ viewOnlyRepSignatureDate }}</span></p>
        <p>{{ 'SIGNATURE_CAPTURED_BY' | translate }}: {{ repSignatureCapturedBy }}</p>
      </ng-container>
    </div>
  </div>
</div>
